import { Content, ContentSource } from "../types";

export function generateContent(source: ContentSource): Content {
  return source as unknown as Content;
}
